export default defineNuxtRouteMiddleware((to, from) => {
  useAuth().init()
  useAuth().refresh()
})
